define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/def",
	"csi/def/ViewStoreBuilder",
	"csi/locale",
	"csi/reflection"
], function(declare, csi, _, Controller, def, ViewStoreBuilder, locale, reflection) {

	// Add entries to objects below if they are valid omissions
	var _omitTypes = {
		"_CS_ClientViewHolder": 1,
		"_CS_PreferenceContainer": 1,

		// no views on these
		"AttributeValuePusher": 1,
		"BPExpressions": 1,
		"CalendarExpressions": 1,
		"Comment": 1,
		"CommentBase": 1,
		"CommentReply": 1,
		"DeviationRange": 1,
		"DocumentManager": 1,
		"DutyRateUsageReport": 1,
		"ExternalImageStore": 1,
		"ExternalExporterRegistry": 1,
		"MerchDetails": 1,
		"ProductSpecAdmin": 1, // special view
		"PruneState": 1,
		"QualityAdmin": 1,
		"QueryFilter_BooleanExpression": 1,
		"Scorecard": 1,
		"SiteLibSupplierItem": 1,
		"SitePreferences": 1,
		"SizeChartAdmin": 1,
		"SizeChartReviewSize": 1,
		"StylePushTemplate": 1, // special view
		"TableColumnReport": 1,
		"TableReport": 1,
		"TagSpec": 1,
		"TrackActivityExpressions": 1,
		"UserPreferences": 1,
		"WbsRequest": 1,
	};

	// Add attributes below if they are valid omissions (ClassName: [AttributeNames])
	var _omitAttributes = {

	};

	function _filterClass(rc) {
		return !_omitTypes[rc.getType()] && !rc.isDerivedFrom("_CS_Executable");
	}

	function _filterAttribute(id, type) {
		return !_.contains(_omitAttributes[type], id);
	}

	return declare(Controller, {
		toWriter: function() {
			// summary: determine missing attribute and view localizations
			var types = {};
			var rcs = reflection.getClasses();
			var lr = locale.getResolver({
				bSubstitute: false,
				bUseDefault: false
			});

			// check attributes for each type
			_.each(rcs, function(rc) {
				if (!_filterClass(rc)) return;

				var type = rc.getType();
				var typeAttr;

				_.each(rc.getAttributes(true), function(rca) {
					var id = rca.getId();

					if (!_filterAttribute(id, type)) return;

					if (rca.isCustom || rca.isHidden) return;

					if (rca.isSecondary) return;

					if (!lr.getTypeAttribute(type, id) && !lr.getResourceIfExists(id)) {
						typeAttr = typeAttr || {};
						typeAttr[id] = "";
					}
				});

				if (typeAttr) {
					types[type] = {Attr: typeAttr};
				}
			});

			// check views for each portal and type
			_.each(["__Host__", "__Customer__", "__SalesDivision__", "__Supplier__"], function(portalViewId) {
				var typeStore = def.getPortalTypeStore(portalViewId);

				typeStore.query().forEach(function(typeItem) {
					var type = typeStore.getIdentity(typeItem);
					var viewStore = ViewStoreBuilder.getStore(type, portalViewId);

					viewStore.query().forEach(function(viewItem) {
						if (!viewItem.hasName) {
							var typeOwner = def.decomposeViewKey(viewItem.id).type;
							var typeObj = types[typeOwner] = types[typeOwner] || {};
							var viewObj = typeObj.View = typeObj.View || {};
							viewObj[viewItem.viewId] = "";
						}
					});
				});
			});

			var w = window.open("", "Localization");
			var doc = w.document;
			doc.write("<HTML><HEAD><TITLE>Localization Type Omissions</TITLE></HEAD>");
			doc.write("<BODY><pre>");
			doc.write("locale.addTypes(" + csi.objectToString(types, 0, "\n") + ");");
			doc.write("</pre></BODY></HTML>");
			doc.close();
		}
	});
});